import {
  Grid,
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import { CloudUpload } from "@mui/icons-material";

export default function HeadToHeadModeCard({
  mode,
  index,
  versusSettings,
  setVersusSettings,
  loading,
  handleImageUpload,
  createBlobInContainer,
  setLoading,
}) {
  return (
    <Grid item xs={12} sm={6} md={6} key={index}>
      <Box
        key={index}
        sx={{
          mb: 3,
          p: 2,
          border: "1px solid #eee",
          borderRadius: 1,
        }}
      >
        <Typography variant="subtitle1">{mode.title}</Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: 2,
            mt: 2,
          }}
        >
          <TextField
            label="Entry Fee"
            type="number"
            value={mode.entryFee}
            onChange={(e) => {
              const newSettings = { ...versusSettings };
              newSettings.gameModes[index].entryFee = Number(e.target.value);
              setVersusSettings(newSettings);
            }}
            fullWidth
            variant="outlined"
            size="small"
          />
          <TextField
            label="Winnings"
            type="number"
            value={mode.winnings}
            onChange={(e) => {
              const newSettings = { ...versusSettings };
              newSettings.gameModes[index].winnings = Number(e.target.value);
              setVersusSettings(newSettings);
            }}
            fullWidth
            variant="outlined"
            size="small"
          />
          <TextField
            label="Above FPTS"
            type="number"
            value={mode.above}
            onChange={(e) => {
              const newSettings = { ...versusSettings };
              newSettings.gameModes[index].above = Number(e.target.value);
              setVersusSettings(newSettings);
            }}
            fullWidth
            variant="outlined"
            size="small"
          />
          <TextField
            label="Below FPTS"
            type="number"
            value={mode.below}
            onChange={(e) => {
              const newSettings = { ...versusSettings };
              newSettings.gameModes[index].below = Number(e.target.value);
              setVersusSettings(newSettings);
            }}
            fullWidth
            variant="outlined"
            size="small"
          />
        </Box>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" gutterBottom>
            Icon
          </Typography>

          <Box
            sx={{
              width: "100%",
              height: 120,
              backgroundColor: "#f5f5f5",
              border: "1px dashed #ccc",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 1,
              overflow: "hidden",
              position: "relative",
            }}
          >
            {mode.icon ? (
              <img
                src={mode.icon}
                alt="Icon Preview"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            ) : (
              <CloudUpload sx={{ fontSize: 40, color: "#ccc" }} />
            )}

            {loading && (
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <CircularProgress size={32} />
              </Box>
            )}
          </Box>

          <input
            accept="image/*"
            style={{ display: "none" }}
            id={`upload-icon-${index}`}
            type="file"
            onChange={(e) =>
              handleImageUpload({
                event: e,
                index,
                versusSettings,
                setVersusSettings,
                createBlobInContainer,
                setLoading,
              })
            }
          />

          <label htmlFor={`upload-icon-${index}`}>
            <Button variant="outlined" component="span" size="small">
              Upload Image
            </Button>
          </label>
        </Box>
      </Box>
    </Grid>
  );
}
